module.exports = __webpack_public_path__ + "assets/events_terrorism_black.4ecc29cd.svg";